// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"589":"cd7841b4","787":"21bdd81b"}[chunkId] + ".chunk.js";
};